import React from "react";
import Sidebar from "./Sidebar.jsx";

function Page({ children }) {
  return (
    <div className="flex h-screen w-full bg-gray-100">
      <div className="w-1/6 overflow-y-auto">
        <Sidebar />
      </div>

      <div className="w-5/6 bg-white p-10 overflow-y-auto space-y-8 border-l-2 border-gray-200">
        <main>{children}</main>
      </div>
    </div>
  );
}

export default Page;
